import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Fade,
  Grid,
  Paper,
  Typography,
  CircularProgress,
  ClickAwayListener,
} from "@material-ui/core";
import styled from "styled-components";
import getIcon from "../../utils/getIcon";
import SearchList from "../SearchList";
import SelectProvince from "../SelectProvince";

import { store } from "../../Context/Store";
import { GetAddress } from "../../API/Pins";
import { searchStyle } from "./style";
import { ROLE } from "../../utils/constant";

const SearchBarWrapper = styled.div`
  display: flex;
`;

const SearchIcon = styled.span`
  margin: 0 5px;
  display: flex;
  justify-content: cneter;
  align-items: center;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 2px 10px;
  border: 0;
  font-size: 1rem;
  color: #fff;
  outline: none;
  text-align: right;
  direction: rtl;
  background-color: transparent;

  &::-webkit-input-placeholder {
    /* Edge */
    color: #dce4ed;
    text-align: right;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #dce4ed;
    text-align: right;
  }

  &::placeholder {
    color: #dce4ed;
    text-align: right;
  }
`;

const SearchBar = (props) => {
  const [StartSearch, setStartSearch] = useState(false);
  const [ShowResult, setShowResult] = useState(false);

  // const [SearchBy, setSearchBy] = useState("");
  const [Search, setSearch] = useState("");

  const InputRef = useRef();

  const context = useContext(store);
  const { state, dispatch } = context;

  useEffect(() => {
    if (!state.loding) {
      dispatch({ type: "SHOW_LOADING" });
    }

    let timer1 = setTimeout(() => {
      if (Search !== "") {

        async function fetchAddressSuggest() {

          const data = {
            address: Search,
            province_code: state.province,
            region_code: 0,
          };
          try {
            dispatch({ type: "NOT_FOUND_ADDRESS", state: false })
            dispatch({ type: "LOADING_ADDRESS", state: true })
            const GetAddresses = await GetAddress(data);
            dispatch({ type: "SEARCH_RESULT", result: [...GetAddresses] });
            dispatch({ type: "HIDE_LOADING" })
            dispatch({ type: "LOADING_ADDRESS", state: false })
          } catch (e) {
            dispatch({ type: "LOADING_ADDRESS", state: false })
            dispatch({ type: "HIDE_LOADING" })
            dispatch({ type: "NOT_FOUND_ADDRESS", state: true })
            console.dir(e);
          }


        }
        fetchAddressSuggest();
      }
    }, 1500);
    return () => {
      clearTimeout(timer1);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Search]);

  const classes = searchStyle();

  const handleClearSearch = () => {
    props.handleResetMap();
    setSearch("");
  };

  const handleSearchItemWithEnterKey = (e) => {
    if (e.keyCode === 13) {
      if (Search !== "") {
        dispatch({ type: "SHOW_LOADING" });
        const data = {
          province_code: state.province,
          address: Search,
        };

        async function fetchAddressSuggest(data) {
          try {
            dispatch({ type: "NOT_FOUND_ADDRESS", state: false })
            dispatch({ type: "LOADING_ADDRESS", state: true })
            const GetAddresses = await GetAddress(data);
            dispatch({ type: "LOADING_ADDRESS", state: false })
            dispatch({ type: "SET_ADDRESS", address: GetAddresses[0].address })
            dispatch({ type: "HIDE_LOADING" })
            dispatch({ type: "SEARCH_RESULT", result: [...GetAddresses] });
            dispatch({ type: 'SET_LATLNG', latlng: [GetAddresses[0].latitude, GetAddresses[0].longitude] })
          } catch (e) {
            dispatch({ type: "LOADING_ADDRESS", state: false })
            dispatch({ type: "HIDE_LOADING" })
            dispatch({ type: "NOT_FOUND_ADDRESS", state: true })
          }
        }
        fetchAddressSuggest(data);
      }
    }
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (Search === "") {
          setStartSearch(false);
          setShowResult(false);
        }
      }}
    >
      <SearchBarWrapper StartSearch={StartSearch}>
        <Grid container className={classes.outContainer}>
          <Box
            className={classes.innerContainer}
            onClick={() => setStartSearch(true)}
          >
            <SearchIcon tabIndex="0" xs={1}>
              {getIcon("search", { fontSize: 30, color: "white", cursor: 'pointer' })}
            </SearchIcon>
            <SelectProvince />
            <Grid item className={classes.searchTitle} xs={11}>
              <SearchInput
                onKeyDown={handleSearchItemWithEnterKey}
                ref={InputRef}
                // searchBy={SearchBy}
                value={Search}
                placeholder={`جستجو...`}
                onChange={(e) => {
                  setSearch(e.target.value);
                  e.target.value === ""
                    ? setShowResult(false)
                    : setShowResult(true);
                }}
              />
            </Grid>

            {!!Search ? (
              <SearchIcon tabIndex="0" xs={1} onClick={handleClearSearch}>
                {getIcon("close", { fontSize: 17, color: "white" })}
              </SearchIcon>
            ) : null}

          </Box>

          {(state.role === ROLE.MEMBER && !state.editMode) &&
            <Box
              onClick={
                () => {
                  dispatch({ type: "RESET_MAP" });
                  dispatch({ type: "ADD_ADDRESS_MODE", state: !state.addAddressMode });
                }
              }
              className={classes.addAddressButton}
            >
              {!state.addAddressMode ? "Add" : "Cancel"}
            </Box>}

        </Grid>

        {/* Result Search List */}
        <Fade in={ShowResult && !!Search}>
          <Paper elevation={4} className={classes.SearchResult}>
            <Fragment>
              {state.loading && !!Search ? (
                <CircularProgress
                  className={classes.circule}
                  size={32}
                  color="inherit"
                />
              ) : !!!Search ? null : !!state.addressResult.length ? (
                <SearchList />
              ) : (
                <Typography className={classes.invalid}>آدرس نامعتبر</Typography>
              )}
            </Fragment>
          </Paper>
        </Fade>
      </SearchBarWrapper>
    </ClickAwayListener>
  );
};

export default SearchBar;
